var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lg:mt-3"},[_c('div',{staticClass:"text-2xl my-4 lg:hidden md:hidden title font-semibold"},[_vm._v(" My Orders ")]),_c('ClinicOrderList',{attrs:{"viewDetailRoute":"OrderDetail"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }